<!-- Horário de recebimento de propostas: define o momento a partir do qual este
     empreendimento e todas as suas frações aceitam propostas. É um campo do
     formulário como outro qualquer — grava com o botão principal do modal, sem
     Guardar próprio. Só visível a quem pode editar o empreendimento. -->
<div class="border rounded mb-3 px-3 py-2" *ngIf="canEditDevelopment">
    <div class="align-items-center d-flex flex-wrap gap-2">
        <div class="align-items-center d-flex gap-1 me-auto">
            <i class="ri-time-line fs-16 text-muted"></i>
            <span class="fs-14 fw-medium">{{'t-proposals-window.t-title' | translate}}</span>
            <i class="ri-information-line fs-14 text-muted" role="button" container="body"
                [ngbTooltip]="'t-proposals-window.t-help' | translate"></i>
        </div>

        <div class="input-group input-group-sm proposals-window-field" *ngIf="proposalsWindowEnabled">
            <!-- O valor guardado fica em 'Y-m-d H:i' (hora de parede que o servidor
                 espera); o que se vê e escreve é o altInput em dd/mm/aaaa. -->
            <input id="proposalsWindowDraft" type="text" class="form-control flatpickr-input"
                mwlFlatpickr [allowInput]="true" appDateDigitsMask [enableTime]="true" [time24hr]="true" [dateFormat]="'Y-m-d H:i'" [altInput]="true" [altFormat]="'d/m/Y H:i'" [altInputClass]="'form-control flatpickr-input'"
                [convertModelValue]="false" [ngModel]="proposalsWindowDraft"
                (ngModelChange)="onProposalsWindowDraftChange($event)"
                [ngModelOptions]="{standalone: true}" placeholder="DD/MM/AAAA HH:mm"
                [attr.aria-label]="'t-proposals-window.t-datetime' | translate" />
            <span class="input-group-text fs-11 text-muted" *ngIf="proposalsWindowTimezone">
                {{proposalsWindowTimezone}}
            </span>
        </div>

        <div class="form-check form-switch mb-0 ms-1">
            <input class="form-check-input" type="checkbox" role="switch"
                id="proposalsWindowEnabled" [ngModel]="proposalsWindowEnabled"
                (ngModelChange)="toggleProposalsWindow($event)" [ngModelOptions]="{standalone: true}">
            <label class="form-check-label fs-13" for="proposalsWindowEnabled">
                {{'t-proposals-window.t-enable' | translate}}
            </label>
        </div>
    </div>
</div>

<div *ngIf="!isCreateMode && ((propertyProposalsData && propertyProposalsData.length > 0) || (propertyProposalsData.length == 0 && bkpList.length > 0))"
    class="row">
    <div class="col-md-7">
        <div class="d-flex justify-content-between align-items-center mb-3">
            <h3 class="fs-16 mb-0">{{'t-proposals.t-proposals-received' | translate}}</h3>
            <div class="align-items-center d-flex gap-3 justify-content-end w-50">
                <ng-select class="w-50 d-md-block d-none" [items]="statusList" [loading]="!statusList"
                    [multiple]="false" bindLabel="description" bindValue="id" (change)="onChangestatus($event)"
                    placeholder="{{'t-proposals.t-filter-status' | translate}}">
                </ng-select>
                <button (click)="newProposal(content)" [disabled]="proposalsWindow?.blocked"
                    class="btn btn-outline-primary waves-effect waves-primary btn-sm">
                    <i class="ri-add-fill me-1 align-bottom" *ngIf="!proposalsWindow?.blocked"></i>
                    <i class="ri-lock-line me-1 align-bottom" *ngIf="proposalsWindow?.blocked"></i>
                    <ng-container *ngIf="!proposalsWindow?.blocked">
                        {{'t-proposals.t-add-proposal' | translate}}
                    </ng-container>
                    <ng-container *ngIf="proposalsWindow?.blocked">
                        {{'t-proposals-window.t-blocked-btn' | translate: {date: proposalsWindow.startAtLabel} }}
                    </ng-container>
                </button>
            </div>
        </div>
        <div *ngIf="propertyProposalsData.length > 0"
            class="accordion custom-accordionwithicon custom-accordion-border accordion-border-box accordion-primary"
            id="accordionBordered">
            <ngx-simplebar [ngStyle]="{ 'height.vh': 55 }">
                <div class="accordion-item mb-2" *ngFor="let proposal of propertyProposalsData;">
                    <h2 class="accordion-header" id="accordionborderedExample{{proposal.id}}">
                        <button (click)="changeProposalSelected(proposal)" id="proposal-{{proposal.id}}"
                            class="accordion-button collapsed align-itens-center d-flex position-relative" type="button"
                            data-bs-toggle="collapse"
                            attr.data-bs-target="#accor_borderedExamplecollapse{{proposal.id}}" aria-expanded="false"
                            attr.aria-controls="accor_borderedExamplecollapse{{proposal.id}}">
                            <span>{{generateProposalRef(proposal.id)}} - {{'t-proposals.t-proposal-title' | translate:
                                {name:
                                proposal.user.name, date:
                                getDate(proposal?.proposalDate)} }}</span>
                            <span *ngIf="proposal?.lastAction"
                                class="badge {{getBadge(proposal?.lastAction?.icon)}} position-absolute"
                                style="right: 6em">
                                {{getProposalStatusLabel(proposal?.lastAction) | translate}}</span>
                            <span *ngIf="!proposal?.lastAction"
                                class="badge {{getBadge(proposal?.firstProposal?.icon)}} position-absolute d-md-block d-none"
                                style="right: 6em">
                                {{getProposalStatusLabel(proposal?.firstProposal) | translate}}</span>
                        </button>
                    </h2>
                    <div id="accor_borderedExamplecollapse{{proposal.id}}" class="accordion-collapse collapse"
                        attr.aria-labelledby="accordionborderedExample{{proposal.id}}"
                        data-bs-parent="#accordionBordered">
                        <div class="accordion-body py-0">
                            <div class="row">
                                <div class="col-12 row">
                                    <div class="card border-0 col-md-6">
                                        <div class="rounded-card card-body p-3">
                                            <h5 class="card-title flex-grow-1 mb-3">{{'t-proposals.t-sent-by' |
                                                translate}}:</h5>
                                            <ul class="list-unstyled mb-0 vstack">
                                                <li class="mb-3">
                                                    <div class="d-flex align-items-center">
                                                        <div class="flex-shrink-0">
                                                            <img src="{{proposal.user && proposal.user?.userFiles?.length > 0 ? pathProfileImage + proposal.user?.userFiles[0]?.fileName : 'assets/images/users/user-dummy-img.jpg'}}"
                                                                alt="" class="avatar-sm rounded">
                                                        </div>
                                                        <div class="flex-grow-1 ms-3">
                                                            <h6 class="fs-14 mb-1">{{proposal.user.name}}</h6>
                                                            <p class="text-muted mb-0">{{proposal?.user?.store}}</p>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li *ngIf="proposal?.agencyProposal && proposal?.partnerEntityName"
                                                    class="d-flex align-items-center">{{'t-proposals.t-partner-agency' |
                                                    translate}}:
                                                    {{proposal?.partnerEntityName}}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="card border-0 col-md-6">
                                        <div class="rounded-card card-body p-3">
                                            <div *ngIf="proposal?.firstProposal" class="mb-3">
                                                <h5 class="card-title flex-grow-1">{{'t-proposals.t-first-proposal' |
                                                    translate}}</h5>
                                                <div class="d-flex align-items-center justify-content-between">
                                                    <div class="mb-1">
                                                        <div class="mb-1">
                                                            {{'t-proposals.t-value' | translate}}:
                                                            {{priceFormat(proposal?.firstProposal?.value)}}</div>
                                                        <div class="mb-1"
                                                            *ngIf="proposal?.agencyProposal && proposal.firstProposal?.saleDivision">
                                                            {{'t-proposals.t-share-commission' | translate}}:
                                                            {{proposal.firstProposal?.saleDivision}}/{{100 -
                                                            proposal.firstProposal?.saleDivision}}</div>
                                                        <div class="mb-1">{{'t-proposals.t-date' | translate}}:
                                                            {{getDate(proposal?.firstProposal?.date)}}</div>
                                                    </div>
                                                    <button
                                                        *ngIf="(permissionsService.checkAgentPermission(property?.mainAgent, 'DELETE_PROPOSALS') && !['ri-trophy-line', 'ri-check-double-line'].includes(proposal?.lastAction?.icon)) || permissionsService.checkMasterPermission('DELETE_PROPOSALS', property?.store?.id)"
                                                        (click)="deleteProposal(proposal.id)"
                                                        class="btn btn-soft-danger px-2 py-1"><i
                                                            class="ri-delete-bin-2-line"></i></button>
                                                </div>
                                            </div>
                                            <div *ngIf="proposal?.lastAction">
                                                <h5 class="card-title flex-grow-1">{{'t-proposals.t-last-action' |
                                                    translate}}</h5>
                                                <div class="d-flex align-items-center justify-content-between">
                                                    <div class="mb-1">
                                                        <div class="mb-1">{{'t-proposals.t-value' | translate}}:
                                                            {{priceFormat(proposal?.lastAction?.value)}}
                                                        </div>
                                                        <div class="mb-1"
                                                            *ngIf="proposal?.agencyProposal && proposal.lastAction?.saleDivision">
                                                            {{'t-proposals.t-share-commission' | translate}}:
                                                            {{proposal.lastAction?.saleDivision}}/{{100 -
                                                            proposal.lastAction?.saleDivision}}</div>
                                                        <div class="mb-1">{{'t-proposals.t-date' | translate}}:
                                                            {{getDate(proposal?.lastAction?.date)}}</div>
                                                    </div>
                                                    <div><span class="badge {{getBadge(proposal?.lastAction?.icon)}}">
                                                            {{getProposalStatusLabel(proposal?.lastAction) | translate}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div *ngIf="getAdditionalProposalDetails(proposal).length > 0 || getProposalProposers(proposal).length > 0"
                                                class="border-top mt-3 pt-3">
                                                <h6 *ngIf="getAdditionalProposalDetails(proposal).length > 0"
                                                    class="fw-semibold mb-2">
                                                    {{ 't-proposals.t-additional-details' | translate }}
                                                </h6>
                                                <div class="mb-1" *ngFor="let detail of getAdditionalProposalDetails(proposal)">
                                                    <span class="text-muted">{{ detail.label }}:</span>
                                                    <span class="ms-1">{{ detail.value }}</span>
                                                </div>

                                                <h6 *ngIf="getProposalProposers(proposal).length > 0"
                                                    class="fw-semibold mb-2 mt-3">
                                                    {{ 't-proposals.t-proposers' | translate }}
                                                </h6>
                                                <div *ngFor="let proposer of getProposalProposers(proposal)" class="mb-2">
                                                    <div>{{ getProposalProposerName(proposer) }}</div>
                                                    <small class="text-muted d-block" *ngIf="getProposalProposerTypeLabel(proposer)">
                                                        {{ 't-proposals.t-proposer-type' | translate }}: {{ getProposalProposerTypeLabel(proposer) }}
                                                    </small>
                                                    <small class="text-muted" *ngIf="getProposalProposerIdentifier(proposer)">
                                                        {{ 't-proposals.t-proposer-tax-id' | translate }}: {{ getProposalProposerIdentifier(proposer) }}
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ngx-simplebar>
        </div>
        <div *ngIf="propertyProposalsData.length == 0 && bkpList.length > 0">
            <div class="py-4 text-center">
                <div>
                    <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop"
                        colors="primary:#405189,secondary:#0ab39c" style="width:72px;height:72px">
                    </lord-icon>
                </div>
                <div class="mt-4">
                    <h5>{{'t-proposals.t-no-proposal-filter' | translate}}</h5>
                </div>
            </div>
        </div>
    </div>
    <div [ngClass]="{'d-flex justify-content-center': !proposalSelected}" class="col-md-5">
        <div class="align-items-center d-flex flex-column gap-2 mt-5" *ngIf="!proposalSelected">
            <i class="fs-2 ri-menu-5-line text-black-50"></i>
            <h3 *ngIf="!proposalSelected" class="fs-15 mb-3">{{'t-proposals.t-select-proposal' | translate}}
            </h3>
        </div>
        <div *ngIf="proposalSelected" class="card-body">
            <ngx-simplebar [ngStyle]="{ 'height.vh': 59 }">
                <div class="profile-timeline">
                    <div class="accordion accordion-flush" id="accordionFlushExample">
                        <div *ngFor="let history of proposalSelected.history; let i = index"
                            class="accordion-item border-0">
                            <div class="accordion-header" id="heading{{i}}">
                                <a class="accordion-button p-2 shadow-none" data-bs-toggle="collapse"
                                    href="#collapse{{i}}" aria-expanded="true" attr.aria-controls="collapse{{i}}">
                                    <div class="d-flex align-items-center">
                                        <div class="flex-shrink-0 avatar-xs">
                                            <div class="avatar-title {{getIconColor(history.icon)}} rounded-circle">
                                                <i class="{{history.icon}} fs-3"></i>
                                            </div>
                                        </div>
                                        <div class="flex-grow-1 ms-3">
                                            <h6 class="fs-15 mb-0 fw-semibold">{{getProposalStatusLabel(history) | translate}} - <span
                                                    class="fw-normal">{{getDate(history.date)}}</span></h6>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div [ngClass]="{'show': i === 0}" id="collapse{{i}}" class="accordion-collapse collapse"
                                attr.aria-labelledby="heading{{i}}" data-bs-parent="#accordionExample">
                                <div class="accordion-body ms-2 ps-5 pt-0">
                                    <h6 *ngIf="history?.value" class="mb-1">{{'t-proposals.t-proposal-value' |
                                        translate}}:
                                        {{priceFormat(history?.value)}}</h6>
                                    <p *ngIf="proposalSelected?.agencyProposal && history.saleDivision"
                                        class="text-muted">{{'t-proposals.t-share-commission' | translate}}:
                                        {{history.saleDivision}}/{{100 -
                                        history.saleDivision}}</p>
                                    <p *ngIf="history.obs" class="text-muted">{{ obsLabelKey(history, proposalSelected.history) | translate }}:
                                        {{history.obs}}</p>
                                    <ng-container *ngIf="history.file && history.file.length > 0">
                                      <div class="d-flex align-items-center pb-2"
                                        *ngFor="let file of history.file">
                                        <div class="flex-shrink-0 avatar-xs">
                                            <div class="avatar-title bg-light rounded">
                                                <i class="ri-file-zip-line fs-20 text-primary"></i>
                                            </div>
                                        </div>
                                        <div class="flex-grow-1 ms-3">
                                            <h6 class="mb-1"><a target="_blank"
                                                    href="{{dirProposalsFiles}}{{proposalSelected.id}}/{{file.fileName}}">{{file.originalName}}</a>
                                            </h6>
                                            <small *ngIf="file?.size"
                                                class="text-muted">{{formatSizeUnits(file.size)}}</small>
                                        </div>
                                    </div>
                                    </ng-container>
                                    <div [ngClass]="{'mt-3': !history.obs && history.file?.length == 0}"
                                        *ngIf="i === 0 && !['ri-trophy-line', 'ri-close-circle-line', 'ri-check-double-line'].includes(history?.icon)"
                                        class="align-items-center d-flex flex-wrap gap-3">
                                        <button
                                            *ngIf="permissionsService.checkMasterPermission('REJECT_PROPOSALS', property?.store?.id) || permissionsService.checkAgentPermission(property?.mainAgent, 'REJECT_PROPOSALS')"
                                            (click)="refuseProposal(proposalSelected.id, history?.value)"
                                            class="btn btn-outline-danger">{{'t-proposals.t-refuse' |
                                            translate}}</button>
                                        <button
                                            *ngIf="permissionsService.checkMasterPermission('MAKE_COUNTEROFFER', property?.store?.id) || permissionsService.checkAgentPermission(property?.mainAgent, 'MAKE_COUNTEROFFER') || permissionsService.checkAgentPermission(proposalSelected?.userId, 'MAKE_COUNTEROFFER')"
                                            (click)="counterProposal(contentCounter, proposalSelected)"
                                            class="btn btn-outline-info">{{'t-proposals.t-counteroffer' |
                                            translate}}</button>
                                        <button
                                            *ngIf="permissionsService.checkMasterPermission('ACCEPT_PROPOSALS', property?.store?.id) || permissionsService.checkAgentPermission(property?.mainAgent, 'ACCEPT_PROPOSALS')"
                                            (click)="acceptProposal(proposalSelected.id, history?.value)"
                                            class="btn btn-outline-success">{{'t-proposals.t-accept' |
                                            translate}}</button>
                                        <!-- Fração de empreendimento, antes de aceitar e só uma vez: proposta ao promotor por e-mail. Mesma permissão do Aceitar. -->
                                        <button
                                            *ngIf="canSendToPromoter(history) && (permissionsService.checkMasterPermission('ACCEPT_PROPOSALS', property?.store?.id) || permissionsService.checkAgentPermission(property?.mainAgent, 'ACCEPT_PROPOSALS'))"
                                            (click)="openSendToPromoter(proposalSelected.id)"
                                            class="btn btn-outline-primary"><i class="ri-mail-send-line align-bottom me-1"></i>{{'t-proposals.t-send-to-promoter' |
                                            translate}}</button>
                                    </div>
                                    <div [ngClass]="{'mt-3': !history.obs && history.file?.length == 0}"
                                        *ngIf="i === 0 && history?.icon === 'ri-check-double-line' && (permissionsService.checkMasterPermission('VALIDATE_PROPOSALS', property?.store?.id) || permissionsService.checkAgentPermission(property?.mainAgent, 'VALIDATE_PROPOSALS'))"
                                        class="align-items-center d-flex gap-3">
                                        <button *ngIf="permissionsService.checkMasterPermission('REJECT_PROPOSALS', property?.store?.id) || permissionsService.checkAgentPermission(property?.mainAgent, 'REJECT_PROPOSALS')" (click)="refuseProposal(proposalSelected.id, history?.value, true)"
                                            class="btn btn-outline-danger">{{'t-proposals.t-cancel' |
                                            translate}}</button>
                                        <button
                                            *ngIf="permissionsService.checkMasterPermission('VALIDATE_PROPOSALS', property?.store?.id) || permissionsService.checkAgentPermission(property?.mainAgent, 'VALIDATE_PROPOSALS') && !this.property?.saleInProgress"
                                            (click)="saleFormModal.openForProposal(proposalSelected, property, allAgents)"
                                            class="btn btn-outline-success">{{'t-proposals.t-check-sale' |
                                            translate}}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--end accordion-->
                </div>
            </ngx-simplebar>
        </div>
    </div>
</div>

<div class="row"
    *ngIf="!isCreateMode && (!propertyProposalsData || propertyProposalsData.length === 0) && (!bkpList || bkpList.length === 0)">
    <div class="col-12 d-flex justify-content-end">
        <button (click)="newProposal(content)" [disabled]="proposalsWindow?.blocked"
            class="btn btn-outline-primary waves-effect waves-primary btn-sm">
            <i class="ri-add-fill me-1 align-bottom" *ngIf="!proposalsWindow?.blocked"></i>
            <i class="ri-lock-line me-1 align-bottom" *ngIf="proposalsWindow?.blocked"></i>
            <ng-container *ngIf="!proposalsWindow?.blocked">
                {{'t-proposals.t-add-proposal' | translate}}
            </ng-container>
            <ng-container *ngIf="proposalsWindow?.blocked">
                {{'t-proposals-window.t-blocked-btn' | translate: {date: proposalsWindow.startAtLabel} }}
            </ng-container>
        </button>
    </div>
    <div class="col-12">
        <div class="py-4 text-center">
            <div>
                <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop"
                    colors="primary:#405189,secondary:#0ab39c" style="width:72px;height:72px">
                </lord-icon>
            </div>
            <div class="mt-4">
                <h5> {{'t-proposals.t-no-proposal' | translate}}</h5>
            </div>
        </div>
    </div>
</div>
<!-- Modal -->
<ng-template #content role="document" let-modal>
    <div class="modal-header p-3 ps-4 bg-soft-primary">
        <h5 class="modal-title" id="inviteMembersModalLabel">
            {{'t-proposals.t-new-proposal' | translate}}
        </h5>
        <button type="button" id="proposal-dismiss-btn" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body p-4">
        <form [formGroup]="proposalForm">
            <div class="row">
                <div class="col-md-12 mb-3">
                    <label for="inventoryValueInput" class="form-label">
                        {{'t-proposals.t-buyer-type' | translate}}:
                    </label>
                    <div class="form-check mb-1">
                        <input (change)="changeType(false)" class="form-check-input" [value]="false" type="radio"
                            name="agencyProposal" id="flexRadioDefault1" formControlName="agencyProposal">
                        <label class="form-check-label" for="flexRadioDefault1">
                            {{'t-proposals.t-private' | translate}}
                        </label>
                    </div>
                    <div class="form-check">
                        <input (change)="changeType(true)" class="form-check-input" [value]="true" type="radio"
                            name="agencyProposal" id="flexRadioDefault2" formControlName="agencyProposal">
                        <label class="form-check-label" for="flexRadioDefault2">
                            {{'t-proposals.t-agency' | translate}}
                        </label>
                    </div>
                </div>
                <!-- <div *ngIf="!form['lead'].value" class="col-md-6 mb-3">
                    <label class="form-label w-100">{{'t-proposals.t-associate-lead' | translate}}</label>
                    <button (click)="openLeads(contentLeads)"
                        class="btn btn-outline-primary">{{'t-proposals.t-select-lead' | translate}}</button>
                </div>
                <div *ngIf="form['lead'].value && leadSelected" class="col-md-6 mb-3">
                    <div class="border border-dashed h-100 p-2 rounded-3">
                        <div class="align-items-center d-flex justify-content-between">
                            <label class="form-label mb-0">{{'t-proposals.t-associated-lead' | translate}}</label>
                            <i (click)="removeLead()"
                                class="fs-16 mdi mdi-trash-can-outline ms-1 text-danger cursor-pointer"></i>
                        </div>
                        <span class="align-items-center d-flex">{{'t-proposals.t-name' | translate}}:
                            {{leadSelected?.name}} </span>
                        <span class="text-muted mt-1">{{'t-proposals.t-received-in' | translate}}:
                            {{getDate(leadSelected?.dateHour)}}</span>
                    </div>
                </div>
                <div *ngIf="!form['contact'].value" class="col-md-6 mb-3">
                    <label class="form-label">{{'t-proposals.t-associate-contact' | translate}}</label>
                    <button (click)="openContacts(contentContacts)"
                        class="btn btn-outline-primary">{{'t-proposals.t-select-contact' | translate}}</button>
                </div>
                <div *ngIf="form['contact'].value && contactSelected" class="col-md-6 mb-3">
                    <div class="border border-dashed h-100 p-2 rounded-3">
                        <div class="align-items-center d-flex justify-content-between">
                            <label class="form-label mb-0">{{'t-proposals.t-associated-contact' | translate}}</label>
                            <i (click)="removeContact()"
                                class="fs-16 mdi mdi-trash-can-outline ms-1 text-danger cursor-pointer"></i>
                        </div>
                        <span class="align-items-center d-flex">{{'t-proposals.t-name' | translate}}:
                            {{contactSelected?.firstName + ' ' +
                            contactSelected?.lastName}} </span>
                    </div>
                </div> -->
                <!-- <div class="col-12 mb-3">
                    <label class="form-label">{{'t-proposals.t-buyers-name' | translate}}</label>
                    <input type="text" [ngClass]="{ 'is-invalid': submited && form['clientName'].errors }"
                        [attr.disabled]="form['contact'].value && form['clientName'].value ? true : null"
                        class="form-control" placeholder="Nome do Cliente Comprador" formControlName="clientName">
                    <div *ngIf="submited && form['clientName'].errors" class="invalid-feedback" align="left">
                        {{'t-name-error-required' | translate}}
                    </div>
                </div> -->
                <div *ngIf="form['agencyProposal'].value" class="col-md-7 mb-3">
                    <label class="form-label">{{'t-partner-entity' | translate}}</label>
                    <input type="text" class="form-control"
                        [ngClass]="{ 'is-invalid': submited && form['partnerName'].errors }"
                        placeholder="{{'t-partner-entity' | translate}}" formControlName="partnerName">
                    <div *ngIf="submited && form['partnerName'].errors" class="invalid-feedback" align="left">
                        {{ 't-name-error-required' | translate }}
                    </div>
                </div>
                <div *ngIf="form['agencyProposal'].value" class="col-md-5 mb-3">
                    <label class="form-label">{{'t-license' | translate}}</label>
                    <input class="form-control" placeholder="{{'t-license' | translate}}"
                        [ngClass]="{ 'is-invalid': submited && form['licenseImo'].errors }" formControlName="licenseImo"
                        formControlName="licenseImo" type="text">
                    <div *ngIf="submited && form['licenseImo'].errors" class="invalid-feedback" align="left">
                        <div *ngIf="form['licenseImo'].errors['required']">
                            {{ 't-license-error-required' | translate }}
                        </div>
                    </div>
                </div>
                <div *ngIf="form['agencyProposal'].value" class="col-md-12 mb-3">
                    <label class="form-label">
                        {{'t-proposals.t-share-commission' | translate}}
                    </label>
                    <div class="values d-flex justify-content-between align-items-center mb-1">
                        <span class="fw-bold">{{'t-proposals.t-my-agency' | translate}}: <span
                                class="fw-normal">{{form['saleDivision'].value}}%</span></span>
                        <span class="fw-bold">{{'t-proposals.t-partner' | translate}}: <span class="fw-normal">{{100 -
                                form['saleDivision'].value}}%</span></span>
                    </div>
                    <input type="range" min="0" max="100" formControlName="saleDivision" class="form-range"
                        id="customRange1">
                </div>
                <div class="col-md-6 mb-3">
                    <label class="form-label">{{'t-proposals.t-proposal-value' | translate}}</label>
                    <input type="text" class="form-control"
                        [ngClass]="{ 'is-invalid': submited && form['value'].errors }" mask="separator"
                        thousandSeparator=" " id="priceInput"
                        placeholder="{{'t-proposals.t-proposal-value' | translate}}" formControlName="value">
                    <div *ngIf="submited && form['value'].errors" class="invalid-feedback" align="left">
                        {{'t-proposals.t-proposal-value-mandatory' | translate}}
                    </div>
                </div>
                <div class="col-md-6 mb-3">
                    <label class="form-label">{{'t-proposals.t-proposal-date' | translate}} </label>
                    <input class="form-control flatpickr-input"
                        [ngClass]="{ 'is-invalid': submited && form['proposalDate'].errors }" type="text"
                        placeholder="{{ 't-general.t-select' | translate }}" mwlFlatpickr [allowInput]="true" appDateDigitsMask [convertModelValue]="true"
                        [dateFormat]="'d/m/Y'" formControlName="proposalDate" />
                </div>
                <div class="col-12 mb-3">
                    <label class="form-label">{{'t-proposals.t-observations' | translate}}</label>
                    <textarea class="form-control" formControlName="obs" rows="3"
                        placeholder="{{'t-proposals.t-observations' | translate}}"></textarea>
                </div>
                <div class="col-md-6">
                    <label class="form-label mb-0">{{'t-proposals.t-file-input' | translate}}</label>
                    <div class="d-flex align-items-center py-2 rounded">
                        <input hidden accept=".jpeg, .jpg, .png, .pdf" class="form-control" type="file" id="input-filec"
                            (change)="onFileChange($event)">
                        <a *ngIf="!form['file'].value" href="javascript:void(0);"
                            class="btn btn-outline-primary btn-label waves-effect waves-light btn-sm"
                            (click)="addFileCostumer()">
                            <div class="d-flex">
                                <div class="flex-shrink-0">
                                    <i class="ri-file-upload-line label-icon align-middle fs-16 me-2"></i>
                                </div>
                                <div class="flex-grow-1">
                                    {{'t-upload-file' | translate}}
                                </div>
                            </div>
                        </a>
                        <div class="d-flex align-items-center border border-dashed p-2 rounded"
                            *ngIf="form['file']?.value">
                            <div class="flex-shrink-0 avatar-sm">
                                <div class="avatar-title bg-light rounded">
                                    <i class="ri-file-zip-line fs-20 text-primary"></i>
                                </div>
                            </div>
                            <div class="flex-grow-1 ms-3">
                                <h6 class="mb-1"><a href="javascript:void(0);">{{form['file'].value?.name}}</a>
                                </h6>
                                <small class="text-muted">{{formatSizeUnits(form['file'].value?.size)}}</small>
                            </div>
                            <div class="hstack gap-3 ms-3 fs-16">
                                <a href="javascript:void(0);" class="text-muted" (click)="deleteFile()"><i
                                        class="ri-delete-bin-line"></i></a>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-light w-xs" data-bs-dismiss="modal"
            (click)="clearForm(); modal.close('')">{{'t-proposals.t-cancel' | translate}}</button>
        <button type="button" class="btn btn-primary w-xs" (click)="submitNewProposal()">
            {{'t-proposals.t-submit-proposal' | translate}}
        </button>
    </div>
</ng-template>

<!-- Modal -->
<ng-template #contentContacts role="document" let-modal>
    <div class="modal-header p-3 ps-4 bg-soft-primary">
        <h5 class="modal-title" id="inviteMembersModalLabel">
            {{'t-proposals.t-contacts' | translate}}
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body p-4">
        <div *ngIf="contacts && contacts.length > 0 && total > 0" class="search-box mb-4">
            <input type="text" class="form-control bg-light border-light"
                placeholder=" {{ 't-search' | translate }} {{ 't-here' | translate }}..." [formControl]="queryField">
            <i class="ri-search-line search-icon"></i>
        </div>
        <div *ngIf="(!contacts || contacts.length === 0) && !noresult"
            class="d-flex flex-wrap gap-3 mb-2 position-absolute top-50 start-50 translate-middle">
            <!-- Growing spinner -->
            <div class="spinner-border text-primary" role="status">
                <span class="sr-only">{{'t-app-config.t-loading' | translate}}...</span>
            </div>
        </div>
        <ngx-simplebar *ngIf="contacts && (total || total == 0)" class="mx-n4 px-4" style="max-height: 225px;">
            <div class="vstack gap-4">
                <div class="d-flex align-items-center" *ngFor="let data of contacts">
                    <div class="flex-grow-1">
                        <h5 class="fs-13 mb-0"><a href="javascript: void(0);" class="text-body d-block">{{data.firstName
                                + ' ' + data.lastName}}</a>
                            <span *ngIf="data.email" class="mt-2 text-muted">E-mail:
                                {{data.email}}</span>
                            <span *ngIf="!data.email && data?.phoneNumber" class="mt-2 text-muted">Telefone:
                                {{data.phoneNumber}}</span>
                        </h5>
                    </div>
                    <div class="flex-shrink-0" *ngIf="form['contact'].value !== data.id">
                        <button type="button" class="btn btn-light btn-sm" (click)="addContact(data)">
                            {{'t-proposals.t-select' | translate}}
                        </button>
                    </div>
                    <div class="flex-shrink-0" *ngIf="form['contact'].value == data.id">
                        <button type="button" class="btn btn-light btn-sm" (click)="removeContact()">
                            {{'t-proposals.t-remove' | translate}}
                        </button>
                    </div>
                </div>
                <!-- end member item -->
            </div>
            <!-- end list -->
        </ngx-simplebar>
        <div class="row justify-content-md-between align-items-md-center mt-4" *ngIf="contacts.length > 0 && total>0">
            <!-- Pagination -->
            <div class="col">
                <div class="text-sm-right me-2 float-sm-end listjs-pagination">
                    <ngb-pagination [collectionSize]="(total)" [maxSize]="6" [(page)]="page" [pageSize]="pageSize"
                        (pageChange)="loadContacts()">
                    </ngb-pagination>
                </div>
            </div>
            <!-- End Pagination -->
        </div>
        <div class="py-4 text-center" *ngIf="noresult">
            <div>
                <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop"
                    colors="primary:#405189,secondary:#0ab39c" style="width:72px;height:72px">
                </lord-icon>
            </div>
            <div class="mt-4">
                <h5>{{'t-no-result-message' | translate}}</h5>
            </div>
        </div>
    </div>
</ng-template>


<!-- Modal -->
<ng-template #contentLeads role="document" let-modal>
    <div class="modal-header p-3 ps-4 bg-soft-primary">
        <!--
            `t-leads` é um NAMESPACE (tem t-gdpr-message e t-phone-call lá
            dentro), não uma string: pedi-lo ao translate devolvia o objecto e
            o título saía como "[object Object]".
        -->
        <h5 class="modal-title" id="inviteMembersModalLabel">
            {{ 'MENUITEMS.LEADS.TEXT' | translate }}
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body p-4">
        <div *ngIf="(!leads || leads.length === 0) && !noresultLeads"
            class="d-flex flex-wrap gap-3 mb-2 position-absolute top-50 start-50 translate-middle">
            <!-- Growing spinner -->
            <div class="spinner-border text-primary" role="status">
                <span class="sr-only">{{'t-app-config.t-loading' | translate}}...</span>
            </div>
        </div>
        <ngx-simplebar *ngIf="leads && (totalLeads || totalLeads == 0)" class="mx-n4 px-4" style="max-height: 225px;">
            <div class="vstack gap-4">
                <div class="d-flex align-items-center" *ngFor="let data of leads">
                    <div class="flex-grow-1">
                        <h5 class="fs-13 mb-0"><a href="javascript: void(0);"
                                class="text-body d-block">{{data.name}}</a>
                            <span *ngIf="data.dateHour" class="mt-2 text-muted">{{'t-proposals.t-date' | translate}}:
                                {{getDate(data.dateHour)}}</span>
                        </h5>
                    </div>
                    <div class="flex-shrink-0" *ngIf="form['lead'].value !== data.id">
                        <button type="button" class="btn btn-light btn-sm" (click)="addLead(data)">
                            {{'t-proposals.t-select' | translate}}
                        </button>
                    </div>
                    <div class="flex-shrink-0" *ngIf="form['lead'].value == data.id">
                        <button type="button" class="btn btn-light btn-sm" (click)="removeLead()">
                            {{'t-proposals.t-remove' | translate}}
                        </button>
                    </div>
                </div>
                <!-- end member item -->
            </div>
            <!-- end list -->
        </ngx-simplebar>
        <div class="row justify-content-md-between align-items-md-center mt-4" *ngIf="leads.length > 0 && totalLeads>0">
            <!-- Pagination -->
            <div class="col">
                <div class="text-sm-right me-2 float-sm-end listjs-pagination">
                    <ngb-pagination [collectionSize]="(totalLeads)" [maxSize]="6" [(page)]="pageLeads"
                        [pageSize]="pageSizeLeads" (pageChange)="loadLeads()">
                    </ngb-pagination>
                </div>
            </div>
            <!-- End Pagination -->
        </div>
        <div class="py-4 text-center" *ngIf="noresultLeads">
            <div>
                <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop"
                    colors="primary:#405189,secondary:#0ab39c" style="width:72px;height:72px">
                </lord-icon>
            </div>
            <div class="mt-4">
                <h5>{{'t-no-result-message' | translate}}</h5>
            </div>
        </div>
    </div>
</ng-template>


<!-- Modal -->
<ng-template #contentCounter role="document" let-modal>
    <div class="modal-header p-3 ps-4 bg-soft-primary">
        <h5 class="modal-title" id="inviteMembersModalLabel">
            {{'t-proposals.t-counteroffer' | translate}}
        </h5>
        <button type="button" id="proposal-dismiss-btn" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body p-4">
        <form [formGroup]="counterProposalForm">
            <div class="row">
                <!-- <div class="col-12 mb-3">
                    <label class="form-label">{{'t-proposals.t-buyers-name' | translate}}</label>
                    <input type="text" [ngClass]="{ 'is-invalid': submitedCounter && formCounter['clientName'].errors }"
                        [attr.disabled]="true" class="form-control"
                        placeholder="{{'t-proposals.t-buyers-name' | translate}}" formControlName="clientName">
                    <div *ngIf="submitedCounter && formCounter['clientName'].errors" class="invalid-feedback"
                        align="left">
                        {{'t-name-error-required' | translate}}
                    </div>
                </div> -->
                <div *ngIf="proposalSelected?.agencyProposal" class="col-md-12 mb-3">
                    <label class="form-label">
                        {{'t-proposals.t-share-commission' | translate}}
                    </label>
                    <div class="values d-flex justify-content-between align-items-center mb-1">
                        <span class="fw-bold">{{'t-proposals.t-my-agency' | translate}}: <span
                                class="fw-normal">{{formCounter['saleDivision'].value}}%</span></span>
                        <span class="fw-bold">{{'t-proposals.t-partner' | translate}}: <span class="fw-normal">{{100 -
                                formCounter['saleDivision'].value}}%</span></span>
                    </div>
                    <input type="range" min="0" max="100" formControlName="saleDivision" class="form-range"
                        id="customRange1">
                </div>
                <div class="col-12 mb-3">
                    <label class="form-label">{{'t-proposals.t-counteroffer-value' | translate}}</label>
                    <input type="text" class="form-control"
                        [ngClass]="{ 'is-invalid': submitedCounter && formCounter['value'].errors }" mask="separator"
                        thousandSeparator=" " id="priceInput"
                        placeholder="{{'t-proposals.t-counteroffer-value' | translate}}" formControlName="value">
                    <div *ngIf="submitedCounter && formCounter['value'].errors" class="invalid-feedback" align="left">
                        {{'t-proposals.t-counteroffer-value-mandatory' | translate}}
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <label class="form-label">{{'t-proposals.t-observations' | translate}}</label>
                    <textarea class="form-control" formControlName="obs" rows="3"
                        placeholder="{{'t-proposals.t-observations' | translate}}"></textarea>
                </div>
                <div class="col-md-6">
                    <label class="form-label mb-0">{{'t-proposals.t-file-input' | translate}}</label>
                    <div class="d-flex align-items-center py-2 rounded">
                        <input hidden accept=".jpeg, .jpg, .png, .pdf" class="form-control" type="file" id="input-filec"
                            (change)="onFileChangeCounter($event)">
                        <a *ngIf="!formCounter['file'].value" href="javascript:void(0);"
                            class="btn btn-outline-primary btn-label waves-effect waves-light btn-sm"
                            (click)="addFileCostumer()">
                            <div class="d-flex">
                                <div class="flex-shrink-0">
                                    <i class="ri-file-upload-line label-icon align-middle fs-16 me-2"></i>
                                </div>
                                <div class="flex-grow-1">
                                    {{'t-upload-file' | translate}}
                                </div>
                            </div>
                        </a>
                        <div class="d-flex align-items-center border border-dashed p-2 rounded"
                            *ngIf="formCounter['file']?.value">
                            <div class="flex-shrink-0 avatar-sm">
                                <div class="avatar-title bg-light rounded">
                                    <i class="ri-file-zip-line fs-20 text-primary"></i>
                                </div>
                            </div>
                            <div class="flex-grow-1 ms-3">
                                <h6 class="mb-1"><a href="javascript:void(0);">{{formCounter['file'].value?.name}}</a>
                                </h6>
                                <small class="text-muted">{{formatSizeUnits(formCounter['file'].value?.size)}}</small>
                            </div>
                            <div class="hstack gap-3 ms-3 fs-16">
                                <a href="javascript:void(0);" class="text-muted" (click)="deleteFileCounter()"><i
                                        class="ri-delete-bin-line"></i></a>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-light w-xs" data-bs-dismiss="modal"
            (click)="clearFormCounter(); modal.close('')">{{'t-proposals.t-cancel' | translate}}</button>
        <button type="button" class="btn btn-primary w-xs" (click)="submitCounterProposal()">
            {{'t-proposals.t-submit-counteroffer' | translate}}
        </button>
    </div>
</ng-template>

<app-sale-form #saleFormModal (proposalChecked)="onProposalChecked($event)"></app-sale-form>
